import React from 'react';
import Chart from 'react-apexcharts';
import { alignedBox } from './AlignedBox';
import { denormalizeFieldName } from './utils';
import { generateColors } from './colors';
import { actualCurrencyFormatter, getFormatterFromData } from './formatters';

export const BarChart = ({ title, data, xField, yField }) => {
  // group data by xField and aggregate yField values
  const groupedData = data.reduce((acc, row) => {
    const key = row[xField] || 'Unknown';
    acc[key] = (acc[key] || 0) + (row[yField] || 0);
    return acc;
  }, {});

  const formatter = getFormatterFromData(groupedData);

  // extract categories and series for ApexCharts
  const categories = Object.keys(groupedData);
  const series = [
    {
      name: yField,
      data: Object.values(groupedData),
    },
  ];

  const options = {
    chart: {
      type: 'bar',
    },
    legend: {
      show: false,
    },
    colors: generateColors(categories.length),
    xaxis: {
      categories,
      labels: {
        style: {
          fontSize: '10px',
        },
        formatter,
      },
      title: {
        text: `${denormalizeFieldName(yField)}`, // x-axis label
        style: {
          fontSize: '10px',
          fontWeight: 'normal',
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: '10px',
        },
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        columnWidth: '50%',
        distributed: true,
        dataLabels: {
          position: 'top',
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      y: {
        formatter: actualCurrencyFormatter,
      },
    },
  };

  return alignedBox(title, (
    <Chart options={options} series={series} type="bar" />
  ));
};
